import React from 'react'

export const ImageLoadingPlaceholder = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center bg-primary-subtle"
      style={{ height: '100%', width: '100%' }}
    >
      <h1>.......</h1>
    </div>
  )
}
